// [claude] /mcp marketing page. Renders under the standard `pages` layout inside
// ScreenWrapper, so it shares the site nav, footer, and Ink theme (2026-07). The
// page background is Ink's base, painted on <body> by applyThemeToDocument, so
// Page stays transparent rather than carrying its own gradient. mcpTheme merges
// the few page-local tokens over the Ink theme ScreenWrapper provides.
import React from 'react';
import styled, { ThemeProvider, createGlobalStyle } from 'styled-components';
import ScreenWrapper from '../../shared/ScreenWrapper';
import { mcpTheme } from './theme';
import HeroSection from './HeroSection';
import ConversationExamples from './ConversationExamples';
import ToolsReference from './ToolsReference';
import SetupGuide from './SetupGuide';
import SecuritySection from './SecuritySection';
import FooterCTA from './FooterCTA';

const GlobalStyle = createGlobalStyle`
  body {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow-x: hidden;
  }

  *, *::before, *::after {
    box-sizing: border-box;
  }

  /* This page used to ship its own layout, whose reset zeroed these. The pages
     layout ships Bootstrap instead, which gives bare headings and paragraphs a
     margin. Element selectors only, so the page's own styled-components win. */
  h1, h2, h3, h4, h5, h6, p {
    margin: 0;
  }

  @media (prefers-reduced-motion: reduce) {
    *, *::before, *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
    }
  }
`;

const Page = styled.div`
  position: relative;
  font-family: ${p => p.theme.fontFamily};
  color: ${p => p.theme.text};
`;

export default function McpMarketing() {
  return (
    <ScreenWrapper>
      <ThemeProvider theme={mcpTheme}>
        <GlobalStyle />
        <Page>
          <HeroSection />
          <ConversationExamples />
          <ToolsReference />
          <SetupGuide />
          <SecuritySection />
          <FooterCTA />
        </Page>
      </ThemeProvider>
    </ScreenWrapper>
  );
}
